module.exports = __webpack_public_path__ + "static/media/arrivednotification.d8bb0ccd.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/components/console/arrivednotification.mp3
// module id = 13037
// module chunks = 0